// extracted by mini-css-extract-plugin
export default {"title":"title-CfvcKrBw","content":"content-N3oUc7gX","image":"image-Jg2Hax6F"};